/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Email_RequiredInputs */

const en_error_email_required = /** @type {(inputs: Error_Email_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Username, email, and password are required`)
};

const ja_error_email_required = /** @type {(inputs: Error_Email_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ユーザー名、メールアドレス、パスワードは必須です`)
};

const fr_error_email_required = /** @type {(inputs: Error_Email_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nom d'utilisateur, e-mail et mot de passe sont requis`)
};

const de_error_email_required = /** @type {(inputs: Error_Email_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benutzername, E-Mail und Passwort sind erforderlich`)
};

/**
* | output |
* | --- |
* | "Username, email, and password are required" |
*
* @param {Error_Email_RequiredInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const error_email_required = /** @type {((inputs?: Error_Email_RequiredInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Email_RequiredInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_error_email_required(inputs)
	if (locale === "ja") return ja_error_email_required(inputs)
	if (locale === "fr") return fr_error_email_required(inputs)
	return de_error_email_required(inputs)
});